import authService from '../components/api-authorization/AuthorizeService'

export const getMostrarTurnos = async () => {
    const token = await authService.getAccessToken();
    const response = await fetch('api/TurnosPorBox/MostrarTurnosActuales/', {
        headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
    });
    
    if (response.status === 401) {
        await authService.signIn();
    }

    const data = await response.json();
    // console.log({data});
    return data;
}